var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAni7(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 13,
    viewBox: "0 0 22 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 0.75C11 0.551088 10.921 0.360322 10.7803 0.21967C10.6397 0.0790178 10.4489 0 10.25 0H1.25C1.05109 0 0.860322 0.0790178 0.71967 0.21967C0.579018 0.360322 0.5 0.551088 0.5 0.75V9.75C0.5 9.94891 0.579018 10.1397 0.71967 10.2803C0.860322 10.421 1.05109 10.5 1.25 10.5C1.44891 10.5 1.63968 10.421 1.78033 10.2803C1.92098 10.1397 2 9.94891 2 9.75V2.5605L11.5955 12.156C11.7361 12.2966 11.9269 12.3756 12.1257 12.3756C12.3246 12.3756 12.5154 12.2966 12.656 12.156L21.281 3.531C21.4216 3.39017 21.5006 3.19924 21.5004 3.00022C21.5003 2.8012 21.4211 2.61038 21.2803 2.46975C21.1394 2.32912 20.9485 2.25019 20.7495 2.25033C20.5504 2.25047 20.3596 2.32967 20.219 2.4705L12.125 10.5645L3.0605 1.5H10.25C10.4489 1.5 10.6397 1.42098 10.7803 1.28033C10.921 1.13968 11 0.948912 11 0.75Z",
    fill: "#C8BEBE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAni7);
export default __webpack_public_path__ + "static/media/Ani7.bfc86b685cb3b9fc981b42b02caaa199.svg";
export { ForwardRef as ReactComponent };